// extracted by mini-css-extract-plugin
module.exports = {"menu":"menuError_menu__4CPg_","dark":"menuError_dark__KIQWH","menuWrapper":"menuError_menuWrapper__B3_wU","logo":"menuError_logo__9mfu9"};